import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";

import "./App.css";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import PageLoader from "./components/PageLoader/PageLoader";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import WhatsAppButton from "./components/WhatsAppButton/WhatsAppButton";
import ErrorPage from "./components/ErrorPage/ErrorPage";
import AboutUs from "./pages/AboutUs/AboutUs";
import ContactUs from "./pages/ContactUs/ContactUs";
import LandingPage from "./pages/LandingPage/LandingPage";
import Products from "./pages/Products/Products";
import Services from "./pages/Services/Services";
import WhyChooseUs from "./pages/WhyChooseUs/WhyChooseUs";

function AppShell() {
  const location = useLocation();

  return (
    <div className="site-shell">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>

      <PageLoader />
      <ScrollToTop />
      <Navbar />

      <div key={location.pathname} className="route-shell">
        <main id="main-content" className="site-main">
          <Routes location={location}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/products" element={<Products />} />
            <Route path="/why-choose-us" element={<WhyChooseUs />} />
            <Route path="/whychooseus" element={<WhyChooseUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </main>
      </div>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
